import React, { useEffect, useState } from "react";     
import { useDispatch, useSelector } from "react-redux";
import {
  get_data_Review_Data,
  get_Single_Review_Data,
} from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import { Dropdown, Modal } from "react-bootstrap";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import { set } from "date-fns";

const UserReview = () => {
  const dispatch = useDispatch();
  const ReviewData = useSelector(
    (state) => state.feedBackReducer.GetReviewData
  );

  const SingleReviewData = useSelector(
    (state) => state.feedBackReducer.GetSingleReviewData
  );

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [astroName, setAstroName] = useState("");
  const [userName, setUserName] = useState("");
  const [loading, setloading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [timeoutId, setTimeoutId] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [FeedbackID, setFeedback] = useState()
  const [EditValue, setEditValue] = useState("");
  const [insertreviedmodel, setInsertreviewmode] = useState(false)
  const [comment, setComment] = useState("")
  const [StarCount, setStarCount] = useState("")
  const[id,setId]=useState("")
  const [addFormData, setaddFormData] = useState({
    comment: "",



  });
 
  const customerID = Number(sessionStorage.getItem('ID'));
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

    dispatch(get_data_Review_Data(setloading, isActive, formattedToday, formattedToday, astroName, userName)
    );
  }, [dispatch]);

  const handleSearch = () => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      FromDate: formattedStartDate,
      Todate: formattedEndDate,
    };

    dispatch(
      get_data_Review_Data(
        setloading,
        isActive,
        data.FromDate,
        data.Todate,
        astroName,
        userName,

      )
    );
  };


  useEffect(() => {
    dispatch(get_Single_Review_Data(FeedbackID));
  }, [get_Single_Review_Data])



  const handleEditClick = (row) => {
    dispatch(get_Single_Review_Data(row?.FeedbackID));
    setFeedback(row?.FeedbackID)
    setEditModal(true);
  };


  useEffect(() => {
    if (SingleReviewData) {
      setEditValue(SingleReviewData)
    }
  }, [SingleReviewData])



  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
       setId(EditValue[0]?.FeedbackID)
        setComment(EditValue[0]?.Comments)
        setStarCount(EditValue[0]?.StarCount)

      setComment(EditValue[0]?.Comments)


    }

  }, [EditValue]);


  useEffect(() => {
    if (astroName.length < 3 && userName.length < 3) return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(
        get_data_Review_Data(
          setloading,
          isActive,
          startTime,
          endTime,
          astroName,
          userName

        )
      );
      setloading(false);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName, userName]);

  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
    setAstroName("");
    setUserName("");
  };

  const Delete = async (row) => {


    const obj = {
      FeedbackID: row?.FeedbackID, DeleteByUser: customerID,
    }

    await AddUpdate("Feedback/Delete_Feedback", obj);
    swal(
        "Good job!",
        `Successfully Deleted`,
        "success"
      );
  
     dispatch(get_data_Review_Data(setloading,isActive,startTime,endTime, astroName,userName));
    
}
const insertmodel=()=>{
  setStarCount("" )
    setComment("")

    setInsertreviewmode(true)

  }

  const handleAddReview = async () => {

    const obj = {
      AstroID: "",
      UserID: "",
      StarCount: StarCount,
      Comments: comment,
      Status: "",
      CreatedByUser: "1",
      Type: ""
    }
    if (StarCount === "" || comment.trim() === "") {
      swal('Oops', "please fill required fields", "error");
    }
    else {


      await AddUpdate("Feedback/Insert_Feedback", obj)
      swal('Good job!', 'Successfully Added', "success");
      setInsertreviewmode(false);
      dispatch(
        get_data_Review_Data(
          setloading,
          isActive,
          startTime,
          endTime,
          astroName,
          userName

        )
      );
    }
  }



    const UpdateAddReview = async () => {

    const obj = {
      AstroID: "",
      UserID: "",
      StarCount: StarCount,
      Comments: comment,
      Status: "",
      CreatedByUser: "1",
      FeedbackID: id,
      Type: ""
    }
    if (StarCount === "" || comment.trim() === "") {
      swal('Oops', "please fill required fields", "error");
    }
    else {


      await AddUpdate("Feedback/Update_Feedback", obj)
      swal('Good job!', 'Successfully Update', "success");
  
      setEditModal(false);
      dispatch(
        get_data_Review_Data(
          setloading,
          isActive,
          startTime,
          endTime,
          astroName,
          userName

        )
      );
    }
  }




  const columns = [
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Astrologer Name",
      selector: (row) => row.Astrologers,
      sortable: true,
    },

    {
      name: "Star Rating",
      selector: (row) => (
        row.StarCount
        
      ),
      sortable: true,
    },

    {
      name: "Comments",
      selector: (row) => { 
        const words = row?.Comments?.split(" ");
        return words?.length > 15
          ? words?.slice(0, 15)?.join(" ") + "..."
          : row?.Comments;
      },
      sortable: true,
    },

    {
      name: "Date",
      selector: (row) => row.CreatedDtTm,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown drop="up">
            <Dropdown.Toggle  variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" renderOnMount popperConfig={{ strategy: "fixed" }} className="dropdown-menu-right" s >
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Show Full Comment
              </Dropdown.Item>
              <Dropdown.Item onClick={() => Delete(row)}>
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];
  return (
    <div>

      <div className="form-group main_card position-relative">

        <div className="d-flex justify-content-between align-items-center">
          <h2 style={{ color: '#f7931e', fontWeight: 700 }}>All Reviews</h2>
          <button className="btn btn-warning"
            onClick={insertmodel}
          >
            Add Reviews
          </button>
        </div>

        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              // className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
              // className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
              // className="form-control"
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">Name must be at least 3 characters</span>
            )}
          </div>

          <div className="col-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
              // className="form-control"
              value={userName}
              placeholder="Enter user name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setUserName(input);
                }
              }}
            />
            {userName.length > 0 && userName.length < 3 && (
              <span className="text-danger">Name must be at least 3 characters</span>
            )}
          </div>

          <div className="col-3">
            <button className="btn btn-primary mt-3" onClick={handleSearch}>
              Search
            </button>
            <button
              className="btn btn-secondary mt-3 ms-2"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        </div>
      </div>



      <Modal
        className="modal fade "
        show={editModal}
        onHide={setEditModal}
        backdrop="static"
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Full Comment</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal(false)}
                  data-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body p-3">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="form-group">
                    <label className="form-label">Comment</label>

                    <input
                      type="text"
                      className="form-control"
                      name="comment"
                      value={comment}
                       onChange={(e) => setComment(e.target.value)}
                      // readOnly
                      placeholder=""
                      style={{
                        // width: `${comment?.length * 8}px`,
                        height:`${comment?.length * 2}px`,
                    
                        minWidth: "200px", 
                        minHeight:"100px",
                        maxHeight:"100%",
                        maxWidth: "100%", 
                        overflow: "hidden",
                        textWrap: "wrap",
                        textAlign: "justify"
                      }}
                      required
                    />
                  </div>
                </div>

<div className="add-contact-box">
                  <div className="form-group">
                    <label className="form-label">Star</label>

                    <input
                    // style={{width:"42%"}}
                      type="number"
                      className="form-control"
                       name="StarCount"
                       value={StarCount}
                      onChange={(e)=>setStarCount(e.target.value)}
                      placeholder=""
                      // readOnly
                      required
                    />
                  </div>
                </div>



              </div>

              <div className="modal-footer">

<button style={{ color: "black" }}
                  type="button"
                  onClick={
                    UpdateAddReview

                  }
                  className="btn btn-success"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Update
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setEditModal(false);

                  }}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>





      <Modal
        className="modal fade "
        show={insertreviedmodel}
        onHide={setInsertreviewmode}
        backdrop="static"
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Insert Review/ Rating </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setInsertreviewmode(false)}
                  data-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body p-3">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="form-group">
                    <label className="form-label">Comment</label>

                    <input
                      type="text"
                      className="form-control"
                      name="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder=""
                      required
                    />
                  </div>
                </div>

                <div className="add-contact-box">
                  <div className="form-group">
                    <label className="form-label">Star</label>

                    <input
                      type="number"
                      className="form-control"
                      name="StarCount"
                      value={StarCount}
                      onChange={(e) => setStarCount(e.target.value)}
                      placeholder=""
                      required
                    />
                  </div>
                </div>



              </div>

              <div className="modal-footer">

                <button style={{ color: "black" }}
                  type="button"
                  onClick={
                    handleAddReview

                  }
                  className="btn btn-success"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Save
                </button>





                <button
                  type="button"
                  onClick={() => {
                    setInsertreviewmode(false);

                  }}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>











      <div className="col-12 mt-2 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={ReviewData || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />
        )}
      </div>
    </div>
  );
};
export default UserReview;
